module.exports = __webpack_public_path__ + "static/media/bpm_white.66989393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/bpm_white.svg
// module id = 970
// module chunks = 0